import React from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";
import Table from "../table/tableSubmissionDate";
import { getLatestStrainBySubmissionDate } from "../../service/latestStrainData";
import { useInterval } from "../../util/useInterval";
import { removeMissingFields } from "../../util/parseTableData";

import LatestStrainTableStyle from "./latestStrainTable.module.css";
import {
  getLatestStrainBySubmissionDateTableHeaders,
  getLatestStrainDisclaimer,
  getLatestStrainBySubmissionDateTableTitle,
} from "../../service/textRetrieval";
import { getAcknowledgement } from "../../service/acknowledgement";
import ReactTooltip from "react-tooltip";

const LatestStrainTable = ({ textLiterals, variant = "ukvui" }) => {
  const [isLoading, setIsLoading] = React.useState(true);

  const [data, setData] = React.useState([]);
  const [ack, setAck] = React.useState("");

  const [title, setTitle] = React.useState("");
  // const [titletmp, setTitletmp] = React.useState("");
  const [disclaimer, setDisclaimer] = React.useState("");
  const columns = React.useRef([]);

  // function countUnique(iterable) {
  //   return new Set(iterable).size;
  // }

  React.useEffect(() => {
    setIsLoading(true);
    setTitle(getLatestStrainBySubmissionDateTableTitle(textLiterals));
    columns.current = getLatestStrainBySubmissionDateTableHeaders(textLiterals);
    setDisclaimer(getLatestStrainDisclaimer(textLiterals));
    getLatestStrainBySubmissionDate(variant).then((result) => {
      setData(removeMissingFields(result));
      setIsLoading(false);
    });
  }, [variant, textLiterals]);

  // React.useEffect(() => {
  //   let noOfGenomes = (countUnique(data.map(x => x.strain_name)));
  //   let noOfCountries = (countUnique(data.map(x => x.country)));
  //   setTitle(titletmp.replace("<noOfGenomes>", noOfGenomes).replace("<noOfCountries>", noOfCountries))
  //   // setIsLoading(false);
  // }, [data]);

  const fiveMinutes = 1000 * 60 * 5; // in milliseconds
  useInterval(() => {
    getLatestStrainBySubmissionDate(variant).then((result) =>
      setData(removeMissingFields(result))
    );
  }, fiveMinutes);

  const mouseEnter = ({ rowData }) => {
    return () => {
      setAck("Loading...");
      getAcknowledgement(rowData.accession_id).then((result) => {
        if (result.covv_orig_lab === undefined) {
          setAck("The data is still being updated");
        } else {
          setAck(
            `<div>
              <p><strong>GISAID Accession: </strong>${rowData.accession_id}</p>
              <p><strong>Originating Lab: </strong>${result.covv_orig_lab}</p>
              <p><strong>Submitting Lab: </strong>${result.covv_subm_lab}</p>
              <strong>Authors: </strong>${result.covv_authors}
            </div>`
          );
        }
      });
    };
  };

  const mouseLeave = () => {
    return () => {
      setAck("");
    };
  };

  return (
    <div className={`${LatestStrainTableStyle.fullWidth} `}>
      <h2 className={LatestStrainTableStyle.title} data-tip="">
        {title ?? "Most recent reported occurrences in different countries"}
      </h2>
      <Table
        columns={columns.current}
        data={data}
        mouseEnter={mouseEnter}
        mouseLeave={mouseLeave}
        dataTipField="accession_id"
        icon={<AiOutlineInfoCircle />}
        iconCol="Virus Name"
        isLoading={isLoading}
        downloadFileName="recentReportedOccurrences.csv"
        disclaimer={disclaimer}
      />
      <ReactTooltip
        id={"tooltipLatestStrainTableSubmissionDate"}
        html={true}
        insecure={true}
        effect={"float"}
        className={LatestStrainTableStyle.tooltip}
        getContent={(dataTip) => {
          ReactTooltip.rebuild();
          return dataTip === "" ? "" : ack;
        }}
      />
    </div>
  );
};

export default LatestStrainTable;
